import styled from 'styled-components';

export const StyledDefaultSection = styled.div<{ textColor: string }>`
  font-family: var(--font-family), Arial;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  color: ${({ textColor }) => textColor};
  display: inline-flex;
  gap: 5px;
  align-items: center;
  margin-top: 8px;
  max-width: 100%;
  .section-default__prefix-image,
  .section-default__suffix-image {
    max-width: 100%;
    max-height: 50px;
    height: auto;
    flex-shrink: 0;
  }

  .section-default__section-name {
    flex-grow: 1;
    text-align: center;
  }
`;
